import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { QaiInnerWrapComponent } from '@qai/ui';
import { PersonalizedProductListComponent } from './personalized-product-list/personalized-product-list.component';
import { AmplitudeTrackingEvents } from 'src/app/utils/enums/amplitude/amplitudeTrackingEvents.enum';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';
import { TranslationService } from 'src/app/services/translation.service';
import {
  getAccountNameByUuid
} from 'src/app/utils/local-storage.util';

@Component({
  selector: 'app-personalized-practice',
  templateUrl: './personalized-practice.component.html',
  styleUrls: ['./personalized-practice.component.scss'],
  standalone: true,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'personalizedPractice',
    },
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    QaiInnerWrapComponent,
    PersonalizedProductListComponent,
  ],
})
export class PersonalizedPracticeComponent implements OnInit {
  userFirstName: string = '';
  accountName: string = '';
  accountUuid: string = '';
  isTranslationLoaded: boolean = false;
  constructor(
    private amplitudeService: AmplitudeService,
    private translationService: TranslationService
  ) {}

  ngOnInit(): void {
    this.translationService
      .loadScopedTranslation('personalizedPractice')
      .then(() => {
        this.isTranslationLoaded = true;
      });
    this.userFirstName = localStorage.getItem('user_first_name') || '';
    this.accountUuid = localStorage.getItem('current_account_uuid') || '';
    this.accountName = getAccountNameByUuid(this.accountUuid);

    this.amplitudeService.trackEvent(
      AmplitudeTrackingEvents.PERSONALIZED_PRACTICE_DASH_PAGEVIEW, {
        account_name: this.accountName,
      }
    );
  }
}
